<template>
  <div class="layer_list_pan_container" v-show="showList">
    <div class="lists" :style="{ height: '80%' }">
      <div class="list-title">图层管理</div>
      <div class="tree">
        <el-collapse v-model="defaultOpenArr1">
          <el-collapse-item v-for="(cateitem, index) in list" :key="index" :name="index">
            <template slot="title">
              <span>{{ cateitem.label }}</span>
            </template>
            <el-collapse v-model="defaultOpenArr2">
              <el-collapse-item
                v-for="(item, index) in cateitem.children"
                :key="index"
                :name="index"
              >
                <template slot="title">
                  <span style="margin-left: 20px">{{ item.label }}</span>
                </template>
                <div
                  class="checkout-box-container"
                  style="margin-left: 20px"
                  v-for="(layer, childId) in item.children"
                  :key="childId"
                >
                  <div class="checkout-box-row" :id="'checkout-box-row-' + layer.id">
                    <el-checkbox
                      :label="layer.id"
                      :disabled="
                        (layer.type === 'CustomTerrain' ||
                          layer.type === 'GlobeTerrain') &&
                        mapmode === '二维'
                      "
                      v-model="layer.checked"
                      @change="handleCheckboxChange(layer)"
                    >
                      {{ layer.label }}
                    </el-checkbox>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LayerListPan",
  props: {
    map: {
      Legendtype: Object,
    },
  },
  components: {},
  data() {
    return {
      showList: true,
      list: [],
      defaultOpenArr1: [],
      defaultOpenArr2: [],
      mapmode: "",
    };
  },
  watch: {},

  methods: {
    //递归遍历并进行设置
    findMutex(mutex, data, currentbox) {
      if (data.length > 0) {
        data.forEach((item) => {
          if (item.mutex && item.mutex === mutex) {
            if (currentbox.id !== item.id) {
              item.checked = false;
              map3d_viewer.viewer.mouseHandlerManager.trigger("removeLayer", item);
            }
          }
          if (item.children) {
            this.findMutex(mutex, item.children, currentbox);
          }
        });
      }
    },
    /**
     * 增减图层
     */
    handleCheckboxChange(data) {
      const addorremove = data.checked;
      const mutex = data.mutex;
      if (mutex) {
        this.findMutex(mutex, this.list, data);
      }
      if (addorremove) {
        map3d_viewer.viewer.mouseHandlerManager.trigger("addLayer", data);
      } else {
        map3d_viewer.viewer.mouseHandlerManager.trigger("removeLayer", data);
      }
    },
    //生成随机ID
    genUid() {
      var soup_ =
        "!#$%()*+,-./:;=?@[]^_`{|}~ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var length = 20;
      var soupLength = soup_.length;
      var id = [];
      for (var i = 0; i < length; i++) {
        id[i] = soup_.charAt(Math.random() * soupLength);
      }
      return id.join("");
    },
  },

  created: function () {
    this.list = Object.assign([], window.layerManagerConfig);
    this.list.forEach((item, index) => {
      this.defaultOpenArr1.push(index);
      item.children.forEach((item2, index2) => {
        this.defaultOpenArr2.push(index2);
        item2.children.forEach((item3, index3) => {
          item3.id = this.genUid();
          if (item3.checked) {
            map3d_viewer.viewer.mouseHandlerManager.trigger("addLayer", item3);
          }
        });
      });
    });
    map3d_viewer.viewer.mouseHandlerManager.listen("showList", (show) => {
      this.showList = show;
    });
    map3d_viewer.viewer.mouseHandlerManager.listen("mapmodeChange", (mapmode) => {
      this.mapmode = mapmode;
    });
  },
};
</script>

<style>
.more_bt_content {
  display: none;
  flex-direction: column;
  background-color: #fff;
  border-radius: 0px;
}
.option-container {
  padding: 4px;
}
.option-close-container {
  text-align: right;
  color: rgba(200, 200, 200, 1);
  font-size: 13px;
  margin-bottom: 4px;
}
.option-close-bt :hover {
  cursor: pointer;
}
.opacity-option-container {
  width: 120px;

  padding: 8px 16px;
}
.close-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: rgba(200, 200, 200, 1);
  font-size: 13px;
}
.opacity-close-bt :hover {
  cursor: pointer;
}
.el-button-group {
  display: flex;
  flex-direction: column;
}
.el-button--primary {
  margin-top: 1px;
}
.lists {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: absolute;
  text-align: center;
  top: 10%;
  left: 1%;
  font-size: 35px;
  background-color: #fff;
  border-radius: 0px;
  height: 80%;
  width: 15%;
}

.list-title {
  background-color: #4d4d4d;
  color: #fff;
  font-size: 20px;
  height: 40px;
  font-weight: bold;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding-top: 10px;
}
.tree {
  height: 90%;
  overflow-y: scroll;
  padding-left: 8px;
}
.checkout-box-container {
  display: flex;
  flex-direction: column;
  text-align: left;
  padding-left: 12px;
}
.checkout-box-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 16px;
}
.bt_more :hover {
  cursor: pointer;
}

.el-collapse-item__header {
  font-size: 14px;
  height: 32px !important;
}
.el-collapse-item__content {
  padding-bottom: 0px !important;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
  background: hsla(0, 0%, 100%, 0.6);
}

::-webkit-scrollbar-track {
  border-radius: 0;
}
::-webkit-scrollbar-thumb {
  border-radius: 0;
  background-color: rgba(95, 95, 95, 0.4);
  transition: all 0.2s;
  border-radius: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/layerlist.vue